module.exports = __webpack_public_path__ + "62b9372c0a50ef9eb9fd8998ecd1c271.svg";